export default __webpack_public_path__ + "static/media/Newcomer.7a18a5cb.png";